<template>
    <main id="mainCtrl">
        <NewsDialog ref="newsDialog"/>
        <header>
            <button @click="createPromotion">
                <span>Добавить новость</span>
            </button>
        </header>
        <v-table id="clinicNewsTable"
                 request-uri="news/getList"
                 pagesize="50"
                 :lazycount="false"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="img" width="170">
                        Картинка
                    </v-th>
                    <v-th name="description" sort="description" minwidth="200">
                        Текст
                    </v-th>
                    <v-th name="created" sort="created_at" width="85" highlight="*">
                        Добавлена
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="img"></v-th>
                    <v-th name="description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="created" v-slot="{filter}">
                        <date-picker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer', {'warning': item.moderationNeeded}]" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="img" height="24">
                        <img
                            v-if="item.img"
                            src=""
                            alt=""
                            class="avatar"
                            :src="item.img ? storagePublicUrl + '/images/news/265x149/' + item.img : ''"
                            width="160"
                            height="90"/>
                    </v-td>
                    <v-td name="description">
                        <span class="max5LinesText" v-html="item.description" />
                    </v-td>
                    <v-td name="created" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>

        </v-table>
    </main>
</template>
<script>
    import NewsDialog from "@dialogs/NewsDialog";
    import DatePicker from "@base/DatePicker";
    import {STORAGE_PUBLIC} from "@global/const";

    export default {
        components: {
            NewsDialog,
            'date-picker': DatePicker,
        },
        props: {
            city: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        },
        methods: {
            handleRowClick(event, row, item) {
                row.startLoadingAnimation();
                this.axios.get('news/read/' + item.id)
                    .then(response => {
                        this.$refs.newsDialog.read(response.data, this.city, this.url)
                        row.stopLoadingAnimation()
                    })
                    .catch(() => row.stopLoadingAnimation());
            },
            createPromotion() {
                this.$refs.newsDialog.create()
            }
        },
        computed:{
            storagePublicUrl() {
                return STORAGE_PUBLIC;
            },
        }
    }
</script>

<style lang="scss">
#clinicNewsTable span.max5LinesText {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;

    & p{
        margin: 0;
    }
}
</style>
